import PropTypes from 'prop-types';

import { FormattedMessage } from '@zenbusiness/application-commons-intl';
import Divider from '@zenbusiness/zui/Divider';
import Skeleton from '@zenbusiness/zui/Skeleton';
import Text from '@zenbusiness/zui/Text';

import { HomeSection } from '#client/components/HomeSection';
import { INFO_TOOLTIP_MESSAGES } from '#client/components/OrderTracker/constants';
import { TrackerCard, ListItemContainer } from '#client/components/OrderTracker/OrderTracker.styles';
import OrderTrackerItem from '#client/components/OrderTracker/OrderTrackerItem';
import { getTitleMessageSuffix } from '#client/components/OrderTracker/utils';

import { useEnterpriseOrderTracker } from './hooks/useEnterpriseOrderTracker';

function Root({ children, loading }) {
  return (
    <HomeSection
      title={(
        <Text color="primary" size="xl" weight="medium" loading={loading}>
          <FormattedMessage id="dashboard.orderTracker.title" />
        </Text>
      )}
    >
      {children}
    </HomeSection>
  );
}

Root.propTypes = {
  children: PropTypes.node,
  loading: PropTypes.bool
};

function EnterpriseOrderTracker() {
  const { items, loading } = useEnterpriseOrderTracker();

  if (loading) {
    return (
      <Root loading>
        <Skeleton height={300} />
      </Root>
    );
  }

  if (!items.length) {
    return null;
  }

  const lastItemIndex = items.length - 1;

  return (
    <Root>
      <TrackerCard>
        {items.map((item, index) => (
          <ListItemContainer key={item.uuid}>
            <OrderTrackerItem
              color={item.color}
              ctaMessageId={`dashboard.orderTracker.orderTaskStatus.${item.status}`}
              hoverTooltipMessageId={item.hoverTooltipMessageId}
              infoTooltipMessageId={INFO_TOOLTIP_MESSAGES[item.type]?.descriptionId}
              infoTooltipTitleId={INFO_TOOLTIP_MESSAGES[item.type]?.titleId}
              titleMessageId={`dashboard.orderTracker.orderTaskType.${item.type}`}
              titleMessageSuffix={getTitleMessageSuffix(item)}
              type={item.type}
              {...item.linkProps}
            />
            {index !== lastItemIndex && <Divider />}
          </ListItemContainer>
        ))}
      </TrackerCard>
    </Root>
  );
}

export default EnterpriseOrderTracker;
